import { render, staticRenderFns } from "./CoverageTable.vue?vue&type=template&id=7ce8547a&"
import script from "./CoverageTable.vue?vue&type=script&lang=js&"
export * from "./CoverageTable.vue?vue&type=script&lang=js&"
import style0 from "./CoverageTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports